import rolesModules from '../../app-conf-privilege/westfield/roles-modules';
import rolesSubModules from '../../app-conf-privilege/westfield/roles-sub-modules';
import rolesHandler from '../../app-conf-privilege/handler';

export default {
    rolesModules,
    rolesSubModules,
    rolesHandler
}